import { Box, Pressable } from '@rbilabs/universal-components';

export const StyledPressable = Pressable.withConfig({
  padding: '$4',
  backgroundColor: Styles.color.cardBackground,
  borderRadius: 8,
  marginBottom: '$2.5',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
});

export const IconContainer = Box.withConfig({
  padding: '$1.5',
  marginRight: '$3',
  backgroundColor: '__legacyToken.icon-active',
  borderRadius: 'full',
});
